import { ICreateScheduleState } from './createScheduleModalContext';
import { CreateScheduleActionTypes, TCreateScheduleAction } from '../createScheduleModalActions';

export const createScheduleReducer = (
	state: ICreateScheduleState,
	action: TCreateScheduleAction,
): ICreateScheduleState => {
	switch (action.type) {
		case CreateScheduleActionTypes.SET_PUSH_TYPE:
			return {
				...state,
				pushType: action.payload.pushType,
			};
		case CreateScheduleActionTypes.CHANGE_SCHEDULE:
			return {
				...state,
				schedule: action.payload.schedule,
			};
		case CreateScheduleActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateScheduleActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateScheduleActionTypes.RESET_FIELDS:
			return {
				...state,
				pushType: null,
				schedule: '',
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
